export default __webpack_public_path__ + "static/media/water.79b74d43.svg";